import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';


import { AppComponent } from './app.component';
import { ProcessOeeKpisComponent } from './process-oee-kpis/process-oee-kpis.component';
import { ProcessFirstTimeThroughYieldCalculatorComponent } from './process-first-time-through-yield-calculator/process-first-time-through-yield-calculator.component';
import { ProcessRolledThroughputYieldCalculatorComponent } from './process-rolled-throughput-yield-calculator/process-rolled-throughput-yield-calculator.component';
import { ProcessLaborProductivityComponent } from './process-labor-productivity/process-labor-productivity.component';
import { ProcessPlantUptimeCalculatorComponent } from './process-plant-uptime-calculator/process-plant-uptime-calculator.component';
import { QualityComponent } from './quality/quality.component';
import { SupplyChainOntimeDeliveryCalculatorComponent } from './supply-chain-ontime-delivery-calculator/supply-chain-ontime-delivery-calculator.component';
import { SupplyChainInventoryTurnoverCalculatorComponent } from './supply-chain-inventory-turnover-calculator/supply-chain-inventory-turnover-calculator.component';
import { SupplyChainCapacityUtilizationCalculatorComponent } from './supply-chain-capacity-utilization-calculator/supply-chain-capacity-utilization-calculator.component';
import { SupplyChainDaysInventoryCalculatorComponent } from './supply-chain-days-inventory-calculator/supply-chain-days-inventory-calculator.component';
import { SupplyChainDeliveredCostsCalculatorComponent } from './supply-chain-delivered-costs-calculator/supply-chain-delivered-costs-calculator.component';
import { BusinessReturnOnCapitalCalculatorComponent } from './business-return-on-capital-calculator/business-return-on-capital-calculator.component';
import { BusinessDiscountedPaybackPeriodCalculatorComponent } from './business-discounted-payback-period-calculator/business-discounted-payback-period-calculator.component';
import { BusinessEbitCalculatorComponent } from './business-ebit-calculator/business-ebit-calculator.component';




@NgModule({
  declarations: [
    AppComponent,
    ProcessOeeKpisComponent,
    ProcessFirstTimeThroughYieldCalculatorComponent,
    ProcessRolledThroughputYieldCalculatorComponent,
    ProcessLaborProductivityComponent,
    ProcessPlantUptimeCalculatorComponent,
    QualityComponent,
    SupplyChainOntimeDeliveryCalculatorComponent,
    SupplyChainInventoryTurnoverCalculatorComponent,
    SupplyChainCapacityUtilizationCalculatorComponent,
    SupplyChainDaysInventoryCalculatorComponent,
    SupplyChainDeliveredCostsCalculatorComponent,
    BusinessReturnOnCapitalCalculatorComponent,
    BusinessDiscountedPaybackPeriodCalculatorComponent,
    BusinessEbitCalculatorComponent,
    
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/app.module.ts